import { render, staticRenderFns } from "./BusinessNameFilingTab.vue?vue&type=template&id=13299231&scoped=true&"
import script from "./BusinessNameFilingTab.vue?vue&type=script&lang=js&"
export * from "./BusinessNameFilingTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13299231",
  null
  
)

export default component.exports